export default "__VITE_ASSET__f7e38071__"